module.exports = require('./some');



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/collection/any.js
 ** module id = 401
 ** module chunks = 0
 **/